'use client';

import Link from 'next/link';
import {
  isMarketplaceActive,
  marketplaceNav,
} from '@/config/marketplaceNav';
import {
  isMarketplaceNavItemActive,
  marketplaceNavItems,
} from '@/platform/marketplace/marketplaceNavItems';
import { useMarketplaceSellLabel } from '@/platform/marketplace/useMarketplaceSellLabel';

type Props = {
  pathname: string;
};

export function PaydirtMarketplaceSidebarAccordion({ pathname }: Props) {
  const expanded = isMarketplaceActive(pathname);
  const sellLabel = useMarketplaceSellLabel();
  const items = marketplaceNavItems(sellLabel);

  if (!marketplaceNav.enabled) return null;

  return (
    <div className="paydirt-sidebar__accordion">
      <Link
        href={marketplaceNav.rootHref}
        className={`paydirt-sidebar__accordion-parent paydirt-sidebar__item${expanded ? ' paydirt-sidebar__item--active' : ''}`}
        aria-expanded={expanded}
      >
        <i className="uil uil-shop" aria-hidden />
        <span className="paydirt-sidebar__accordion-label">{marketplaceNav.sectionLabel}</span>
        <i
          className={`uil uil-angle-down paydirt-sidebar__accordion-chevron${expanded ? ' paydirt-sidebar__accordion-chevron--open' : ''}`}
          aria-hidden
        />
      </Link>
      {expanded && (
        <div
          className="paydirt-sidebar__accordion-panel paydirt-sidebar__accordion-panel--open"
          role="group"
          aria-label={marketplaceNav.sectionLabel}
        >
          {items.map((item) => {
            const active = isMarketplaceNavItemActive(item.id, pathname);
            return (
              <Link
                key={item.id}
                href={item.href}
                className={`paydirt-sidebar__item paydirt-sidebar__item--nested${active ? ' paydirt-sidebar__item--active' : ''}`}
              >
                <i className={`uil ${item.icon}`} aria-hidden />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
